import { jsx as l } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ l("svg", { "aria-label": "Pil", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l(
  "path",
  {
    fill: "currentColor",
    d: "M28.146 15.903a1.586 1.586 0 0 0-.078-.36 1.533 1.533 0 0 0-.233-.379L17.633 4.33a1.127 1.127 0 0 0-1.594 0 1.224 1.224 0 0 0 0 1.632l8.492 8.9H5.167a1.166 1.166 0 1 0 0 2.333h19.356l-8.483 8.852a1.224 1.224 0 0 0 0 1.603 1.058 1.058 0 0 0 .797.35 1.078 1.078 0 0 0 .806-.35l10.193-10.883c.106-.108.189-.237.243-.379.042-.109.068-.223.078-.34l-.01-.145Z"
  }
) });
export {
  o as A
};
